import { IsoDate } from '../../types/iso-date';

export function isIsoDate(str: string): str is IsoDate {
  // Match YYYY-MM-DD exactly
  const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!isoDateRegex.test(str)) return false;

  const [year, month, day] = str.split('-').map(Number);
  // Month in JS Date is 0-based
  const date = new Date(year, month - 1, day);
  // Check for valid date: year, month, day must match
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}
